import axios from "axios";
import type { PrintMonthlyScheduleDetailsIn } from "@/pages/human-resources/time-management/endpoints/schedules/print/inout/PrintMonthlyScheduleDetailsIn";
import { openDownloaded } from "@/shared/utils/Download.ts";
import type { PrintDailyScheduleIn } from "@/pages/human-resources/time-management/endpoints/schedules/print/inout/PrintDailyScheduleIn";
import type { PrintMonthlyScheduleIn } from "@/pages/human-resources/time-management/endpoints/schedules/print/inout/PrintMonthlyScheduleIn";

const url_prefix = "/api/rh/temps/planning";

export async function printDailySchedule(
  input: PrintDailyScheduleIn,
): Promise<void> {
  return sendPrintRequest(
    `${url_prefix}/feuillepointage/preparatoire/print`,
    input,
  );
}

export async function printMonthlySchedule(
  input: PrintMonthlyScheduleIn,
): Promise<void> {
  return sendPrintRequest(`${url_prefix}/recapmensuel/print`, input);
}

export async function printMonthlyScheduleDetails(
  input: PrintMonthlyScheduleDetailsIn,
): Promise<void> {
  return sendPrintRequest(`${url_prefix}/recapmensuel/detaille/print`, input);
}

async function sendPrintRequest(url: string, payload: unknown): Promise<void> {
  const response = await axios.post<Blob>(url, payload, {
    responseType: "blob",
    headers: {
      Accept: "application/pdf",
    },
  });
  openDownloaded(response);
}
